'use strict';
module.exports = function (x) {
	var type = typeof x;
	return x !== null && (type === 'object' || type === 'function');
};



//////////////////
// WEBPACK FOOTER
// ./~/is-obj/index.js
// module id = 696
// module chunks = 4